import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token:null,
    currentTrack:null,
    currentUser: null,
    currentReleases:null,
    take: null,
    filters:null,
  },
  getters:{
    getToken: state => {
      return state.token;
    },
    getTake: state => {
      return state.take;
    },
    getCurrentTrack: state => {
      return state.currentTrack;
    },
    getCurrentReleases: state => {
      return state.currentReleases;
    },
    getCurrentUser: state => {
      return state.currentUser;
    },
    getFilters: state => {
      return state.filters;
    }
  },
  mutations: {
    fillToken: (state, payload) => {
      state.token = payload;
    },
    fillFilters: (state, payload) => {
      state.filters = payload;
    },
    fillTake: (state, payload) => {
      state.take = payload;
    },
    emptyTake: (state, payload) => {
      state.take = payload;
    },
    emptyToken: (state) => {
      state.token = null;
    },
    fillCurrentTrack: (state, payload) => {
      state.currentTrack = payload;
    },
    fillCurrentReleases: (state, payload) => {
      state.currentReleases = payload;
    },
    emptyCurrentTrack: state => {
      state.currentTrack = null;
    },
    fillCurrentUser: (state, payload) => {
      state.currentUser = payload;
    }
  },
  actions: {
    FILL_TOKEN: (context,payload) => {
      context.commit('fillToken', payload);
    },
    FILL_FILTERS: (context,payload) => {
      context.commit('fillFilters', payload);
    },
    FILL_TAKE: (context,payload) => {
      context.commit('fillTake', payload);
    },
    EMPTY_TAKE: (context,payload) => {
      context.commit('fillTake', payload);
    },
    EMPTY_TOKEN: (context,payload) => {
      context.commit('emptyToken');
    },
    FILL_CURRENT_TRACK: (context,payload) => {
      context.commit('fillCurrentTrack', payload);
    },
    FILL_CURRENT_RELEASES: (context,payload) => {
      context.commit('fillCurrentReleases', payload);
    },
    EMPTY_CURRENT_TRACK: context => {
      context.commit('emptyCurrentTrack');
    },
    FILL_CURRENT_USER: (context, payload) => {
      context.commit('fillCurrentUser',payload);
    }

  }
})
